import * as React from "react";
import { observer } from "mobx-react-lite";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { Mk8sDraftMobx } from "../../../../mst/stores/mk8s.draft";
import { ProviderLinodeNodePool } from "./nodePool";
import { mk8sMobx } from "../../../../mst/kinds/mk8s/mk8s";

type RouteParams = "index";

interface Props {
  mk8s: mk8sMobx;
  mk8sDraft: Mk8sDraftMobx;
}
const ProviderLinodeNodePoolContainerRaw: React.FC<Props> = ({ mk8s, mk8sDraft }) => {
  const { pathname } = useLocation();

  const { index: indexStr } = useParams<RouteParams>();
  const index = Number(indexStr);

  const l = mk8sDraft.provider_linode;
  const np = l.nodePools.find((np) => np.index === index);

  if (!np) {
    return <Navigate to={`${pathname.split("/-node-pools")[0]}/-node-pools`} />;
  }

  return (
    <ProviderLinodeNodePool
      mk8s={mk8s}
      mk8sDraft={mk8sDraft}
      linode={l}
      nodePool={np}
      index={index}
    />
  );
};

export const ProviderLinodeNodePoolContainer = observer(ProviderLinodeNodePoolContainerRaw);
